import Entity from './Entity';

export default class CharacterMakerActorGroup implements Entity {
  constructor(public id: number, public name: string) {}
}
